// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"
import CheckboxSelectAll from 'stimulus-checkbox-select-all'

const application = Application.start()
application.register('checkbox-select-all', CheckboxSelectAll)
const context = require.context("controllers", true, /-controller\.js$/)
application.load(definitionsFromContext(context))
